import { getField } from 'vuex-map-fields'

export default {
  sidebarState: state => state.sidebar,
  links: state => state.links,
  getField
}
